import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";

/** Ligne supprimable (liste recherche ou fiche détail). */
export type U3144LotDetailOperationTypeDeleteRow = {
  id: string;
  version: number;
  operationTypeCode?: string | null;
};

interface U3144LotDetailOperationTypeDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3144LotDetailOperationTypeDeleteRow>;
  t: TFunction;
  NS: string;
}

function U3144LotDetailOperationTypeDeleteDlg({ handleDelete, t, NS }: U3144LotDetailOperationTypeDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  const rows = handleDelete.selectedRows();
  const count = rows.length;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t(count === 1 ? "msgDeleteOperationType" : "msgDeleteOperationType_other", {
          count,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {rows.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.operationTypeCode ?? row.id}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3144LotDetailOperationTypeDeleteDlg;
